export default function supportsDateInput(): boolean {
    const input = document.createElement('input');
    const notADateValue = 'not-a-date';

    input.setAttribute('type','date');
    input.setAttribute('value', notADateValue);

    return (input.value !== notADateValue);
}
